import React, { useContext, useEffect, useRef, useState } from "react";
import * as tf from "@tensorflow/tfjs";
import * as faceLandmarksDetection from "@tensorflow-models/face-landmarks-detection";
import { FACEMESH_TESSELATION } from "@mediapipe/face_mesh/face_mesh";

import axios from "axios";

import {
  PoseLandmarker,
  FilesetResolver,
  DrawingUtils,
} from "@mediapipe/tasks-vision";

import { AuthContext } from "../../../../context/App-Context";

const TgUserInputtgridfungo = () => {
  ////
  const auth = useContext(AuthContext);

  const fileInputRef = useRef(null);
  const dropZoneRef = useRef(null);

  // Replace isCodeInput with this:
  const [isOcancerzMode, setIsOcancerzMode] = useState(false);

  //////////// user camera START

  ////////// user camera START
  ////////// CAMERA DEBUG SECTION //////////

  ////////// CAMERA SECTION - FIXED FOR MAC/CHROME //////////
  const [showCamera, setShowCamera] = useState(false);
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  // const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [currentFacingMode, setCurrentFacingMode] = useState("user");
  const [hasMultipleCameras, setHasMultipleCameras] = useState(false);
  const [cameraError, setCameraError] = useState(null);
  const [debugInfo, setDebugInfo] = useState("");
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [latestCaptureIds, setLatestCaptureIds] = useState([]); // NEW: Tracks just-taken photos

  // NEW: Safely removes the latest photos if the user clicks "Retake"
  const handleRetake = () => {
    setImages((prev) => {
      const remaining = [];
      prev.forEach((img) => {
        if (latestCaptureIds.includes(img.id)) {
          if (img.previewUrl) URL.revokeObjectURL(img.previewUrl); // Clean up memory
        } else {
          remaining.push(img);
        }
      });
      return remaining;
    });
    setLatestCaptureIds([]); // Reset tracking
    setCapturedPhoto(null); // Clear preview to show video again
  };

  const log = (msg) => {
    //console.log("[Camera]", msg);
    setDebugInfo((prev) => prev + "\n" + msg);
  };

  // Helper to format the time exactly as requested
  const getFormattedTimestamp = () => {
    const now = new Date();
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
      month: "long",
      day: "numeric",
      year: "numeric",
    })
      .format(now)
      .toLowerCase(); // e.g., "3:00 pm edt, september 7, 2026"
  };

  const captureSinglePhoto = (withTimestamp) => {
    return new Promise((resolve) => {
      if (!videoRef.current) return resolve(false);

      const canvas = document.createElement("canvas");
      canvas.width = videoRef.current.videoWidth || 1280;
      canvas.height = videoRef.current.videoHeight || 720;

      const ctx = canvas.getContext("2d");

      // Flip the canvas horizontally ONLY if it's the front-facing camera
      if (currentFacingMode === "user") {
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
      }

      ctx.drawImage(videoRef.current, 0, 0);

      canvas.toBlob(
        (blob) => {
          const previewUrl = URL.createObjectURL(blob);

          // Only get the timestamp if the tgrid toggle is checked
          const captureTime = withTimestamp ? getFormattedTimestamp() : null;

          const newImage = {
            id: Date.now() + Math.random(),
            file: new File([blob], `camera-${Date.now()}.jpg`, {
              type: "image/jpeg",
            }),
            previewUrl,
            hasOverlay: false,
            normalizedTensorData: null,
            timestamp: captureTime,
          };

          setImages((prev) => [...prev, newImage]);
          setLatestCaptureIds((prev) => [...prev, newImage.id]);
          setCapturedPhoto(previewUrl);

          if (withTimestamp) {
            log(`✅ Photo captured at ${captureTime}`);
          } else {
            log(`✅ Photo captured`);
          }

          resolve(true);
        },
        "image/jpeg",
        0.95
      );
    });
  };

  const handleCaptureClick = async () => {
    if (isOcancerzMode) {
      // Takes ONE photo WITH the timestamp
      await captureSinglePhoto(true);
    } else {
      // Takes ONE photo WITHOUT the timestamp
      await captureSinglePhoto(false);
    }
  };

  const openCamera = async () => {
    setCameraError(null);
    // setDebugInfo("Opening camera...");

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "user",
          width: { ideal: 1280, min: 640 },
          height: { ideal: 720, min: 480 },
          frameRate: { ideal: 30 },
        },
        audio: false,
      });

      // log("✅ Stream acquired");
      streamRef.current = stream;

      setShowCamera(true);
      setCapturedPhoto(null);
      setLatestCaptureIds([]);

      // Small delay so React can mount the <video> element
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            // log(
            //   `✅ Metadata loaded → ${videoRef.current.videoWidth}x${videoRef.current.videoHeight}`
            // );
            videoRef.current
              .play()
              .then(() => log("✅ "))
              .catch((e) => log("Play error: " + e.message));
          };
        }
      }, 150);

      const devices = await navigator.mediaDevices.enumerateDevices();
      setHasMultipleCameras(
        devices.filter((d) => d.kind === "videoinput").length > 1
      );
    } catch (err) {
      console.error(err);
      setCameraError(err.message);
      log("❌ " + err.message);
    }
  };

  const switchCamera = async () => {
    const newMode = currentFacingMode === "user" ? "environment" : "user";

    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: newMode,
          width: { ideal: 1280, min: 640 },
          height: { ideal: 720, min: 480 },
          frameRate: { ideal: 30 },
        },
        audio: false,
      });

      log(`✅ Switched to ${newMode} camera`);
      streamRef.current = stream;

      setCurrentFacingMode(newMode);

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            log(`✅ Metadata loaded after switch`);
            videoRef.current.play().catch(console.error);
          };
        }
      }, 150);
    } catch (err) {
      alert("Could not switch camera: " + err.message);
    }
  };

  const capturePhoto = () => {
    if (!videoRef.current) return;

    const canvas = document.createElement("canvas");
    canvas.width = videoRef.current.videoWidth || 1280;
    canvas.height = videoRef.current.videoHeight || 720;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(videoRef.current, 0, 0);

    canvas.toBlob(
      (blob) => {
        const previewUrl = URL.createObjectURL(blob);
        const newImage = {
          id: Date.now() + Math.random(),
          file: new File([blob], `camera-${Date.now()}.jpg`, {
            type: "image/jpeg",
          }),
          previewUrl,
          hasOverlay: false,
          normalizedTensorData: null,
        };

        setImages((prev) => [...prev, newImage]);
        setCapturedPhoto(previewUrl);
        log("✅ Photo captured and added");
      },
      "image/jpeg",
      0.95
    );
  };

  const closeCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
    }
    setShowCamera(false);
    setCapturedPhoto(null);
    setDebugInfo("");
    setCameraError(null);
    setCurrentFacingMode("user");
  };
  ////////// END CAMERA SECTION //////////
  ////////// END CAMERA DEBUG //////////
  ////////// user camera END
  //////// user camera functions END

  /////// user camera END

  const [isCodeInput, setIsCodeInput] = useState(false);
  const [textValue, setTextValue] = useState("");

  const [images, setImages] = useState([]);
  // Structure: { id, file, previewUrl, hasOverlay, normalizedTensorData? }

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [detector, setDetector] = useState(null);
  const [poseLandmarker, setPoseLandmarker] = useState(null);
  const [loadingModel, setLoadingModel] = useState(true);

  const MAX_IMAGES = 10;

  // Load models
  useEffect(() => {
    const loadModels = async () => {
      try {
        await tf.ready();

        const faceDetector = await faceLandmarksDetection.createDetector(
          faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh,
          { runtime: "tfjs", refineLandmarks: true, maxFaces: 10 }
        );
        setDetector(faceDetector);

        const vision = await FilesetResolver.forVisionTasks(
          "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"
        );
        const pose = await PoseLandmarker.createFromOptions(vision, {
          baseOptions: {
            modelAssetPath:
              "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_heavy/float16/1/pose_landmarker_heavy.task",
            delegate: "CPU",
          },
          runningMode: "IMAGE",
          numPoses: 1,
        });
        setPoseLandmarker(pose);

        setLoadingModel(false);
      } catch (err) {
        console.error("Model loading failed:", err);
        setLoadingModel(false);
      }
    };
    loadModels();
  }, []);

  const handleTextChange = (e) => setTextValue(e.target.value);

  const addImages = (files) => {
    const validFiles = Array.from(files).filter((f) =>
      f.type.startsWith("image/")
    );

    const newImages = validFiles
      .slice(0, MAX_IMAGES - images.length)
      .map((file) => ({
        id: Date.now() + Math.random(),
        file,
        previewUrl: URL.createObjectURL(file),
        hasOverlay: false,
        normalizedTensorData: null,
      }));

    setImages((prev) => [...prev, ...newImages]);
  };

  const removeImage = (id) => {
    setImages((prev) => {
      const img = prev.find((i) => i.id === id);
      if (img?.previewUrl) URL.revokeObjectURL(img.previewUrl);
      return prev.filter((i) => i.id !== id);
    });
  };
  const clearAll = () => {
    images.forEach((img) => {
      if (img.previewUrl) URL.revokeObjectURL(img.previewUrl);
    });
    setImages([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // Apply tensor overlay (face mesh + pose) to a specific image
  const applyTensorOverlay = async (imageObj) => {
    if (!detector || !poseLandmarker) {
      alert("Models are still loading...");
      return;
    }

    const img = new Image();
    img.onload = async () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      const tensorData = {
        faces: [],
        pose: null,
        originalWidth: width,
        originalHeight: height,
      };

      // Face Mesh - Normalized ratios
      try {
        const predictions = await detector.estimateFaces(img, {
          flipHorizontal: false,
        });
        predictions.forEach((pred) => {
          const normalizedKeypoints = pred.keypoints.map((kp) => ({
            x: kp.x / width,
            y: kp.y / height,
            z: kp.z || 0,
          }));
          tensorData.faces.push({ keypoints: normalizedKeypoints });
        });
      } catch (e) {
        console.warn("Face mesh error:", e);
      }

      // Pose - Already normalized by MediaPipe
      try {
        const result = poseLandmarker.detect(img);
        if (result.landmarks?.length > 0) {
          tensorData.pose = result.landmarks[0].map((lm) => ({
            x: lm.x,
            y: lm.y,
            z: lm.z,
            visibility: lm.visibility,
          }));
        }
      } catch (e) {
        console.warn("Pose error:", e);
      }

      // Draw preview on canvas (visual feedback only)
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      // Draw face mesh preview
      ctx.strokeStyle = "#00bfff";
      ctx.lineWidth = 1.5;
      tensorData.faces.forEach((face) => {
        FACEMESH_TESSELATION.forEach(([a, b]) => {
          const p1 = face.keypoints[a];
          const p2 = face.keypoints[b];
          if (p1 && p2) {
            ctx.beginPath();
            ctx.moveTo(p1.x * width, p1.y * height);
            ctx.lineTo(p2.x * width, p2.y * height);
            ctx.stroke();
          }
        });
      });

      // Draw pose preview
      if (tensorData.pose) {
        const drawingUtils = new DrawingUtils(ctx);
        const scaledPose = tensorData.pose.map((p) => ({
          x: p.x * width,
          y: p.y * height,
        }));
        drawingUtils.drawConnectors(scaledPose, POSE_CONNECTIONS, {
          color: "#00ff00",
          lineWidth: 4,
        });
      }

      // Update state with tensor data + preview
      setImages((prev) =>
        prev.map((item) =>
          item.id === imageObj.id
            ? {
                ...item,
                hasOverlay: true,
                normalizedTensorData: tensorData,
                processedCanvas: canvas, // only for preview
              }
            : item
        )
      );
    };

    img.src = imageObj.previewUrl;
  };

  // Drag & Drop
  useEffect(() => {
    const dropZone = dropZoneRef.current;
    if (!dropZone) return;

    const handleDrop = (e) => {
      e.preventDefault();
      dropZone.classList.remove("drag-over");
      addImages(e.dataTransfer.files);
    };

    const handleDragOver = (e) => {
      e.preventDefault();
      dropZone.classList.add("drag-over");
    };

    const handleDragLeave = () => dropZone.classList.remove("drag-over");

    dropZone.addEventListener("dragover", handleDragOver);
    dropZone.addEventListener("dragleave", handleDragLeave);
    dropZone.addEventListener("drop", handleDrop);

    return () => {
      dropZone.removeEventListener("dragover", handleDragOver);
      dropZone.removeEventListener("dragleave", handleDragLeave);
      dropZone.removeEventListener("drop", handleDrop);
    };
  }, [images.length]);

  // console.log("hello username");
  // console.log(auth.loginVar);

  // Example: convert processed canvases to blobs if you want overlays in the final post
  const handleSubmit = async () => {
    if (images.length === 0) {
      alert("Please add at least one image.");
      return;
    }

    setIsSubmitting(true);

    //////////// If TempleGrid or not

    //////// if TempleGrid Post vvvvv

    //// Photos with TimeStamp

    //////// if Normal post VVVV

    const imageTimestamps = images.map((img) => img.timestamp);

    try {
      const formData = new FormData();

      //console.log("tgrid file vvvv");
      // console.log(isOcancerzMode);

      const postObjectforSubmital = {
        postText: textValue,
        //postImages: ["imageIds"],
        postOcancerzZrhb: "ZrbID",
        uid: "",
        tgridFile: isOcancerzMode,
        //   postDate: "dateOfPost",
        imageTimestamps: imageTimestamps,
      };

      // Send ONLY original photos (exactly like PhotoVault)
      images.forEach((img) => {
        formData.append("postImages", img.file);
      });

      // Send tensor data as JSON for each image that has it
      const tensorArray = images.map((img) => img.normalizedTensorData || null);
      //formData.append("tensorData", JSON.stringify(tensorArray));

      // Other fields

      // console.log("here's the username");
      // console.log(auth.loginVar);
      formData.append("userUsername", auth.loginVar);
      //   formData.append("postText", textValue);
      formData.append(
        "templeGridNormalPostData",
        JSON.stringify(postObjectforSubmital)
      );
      //   formData.append("uid", "");

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/createtgridPost`,
        formData
      );

      alert("Post uploaded successfully!");

      clearAll();
      setTextValue("");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const POSE_CONNECTIONS = [
    // Face
    [0, 1],
    [1, 2],
    [2, 3],
    [3, 7],
    [0, 4],
    [4, 5],
    [5, 6],
    [6, 8],
    // Torso
    [11, 12],
    [11, 13],
    [12, 14],
    [13, 15],
    [14, 16],
    [11, 23],
    [12, 24],
    [23, 24],
    // Arms
    [13, 15],
    [15, 17],
    [15, 19],
    [15, 21],
    [14, 16],
    [16, 18],
    [16, 20],
    [16, 22],
    // Legs
    [23, 25],
    [25, 27],
    [27, 29],
    [27, 31],
    [24, 26],
    [26, 28],
    [28, 30],
    [28, 32],
    // Feet
    [29, 31],
    [30, 32],
  ];

  return (
    <div
      className="tg-user-input-wrapper"
      style={{
        width: "800px", // Wides out the desktop display
        margin: "0 auto",
      }}
    >
      <div
        className="input-container"
        style={{
          position: "relative",
          padding: "20px",
          paddingBottom: "60px", // Creates space for the absolute bottom-right toggle
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        {/* Unified Input Container */}
        <div style={{ marginBottom: "10px" }}>
          {isOcancerzMode ? (
            <textarea
              className="code-input"
              placeholder="TempleGrid Input..."
              value={textValue}
              onChange={handleTextChange}
              rows={6}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "10px",
              }}
            />
          ) : (
            <input
              type="text"
              className="input-field"
              placeholder="What's happening today?"
              value={textValue}
              onChange={handleTextChange}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "10px",
              }}
            />
          )}
        </div>

        {/* Small Icon for Adding Photos */}
        <div
          style={{
            display: "flex",
            gap: "15px",
            marginBottom: "15px",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            onClick={() => fileInputRef.current?.click()}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              padding: "5px",
            }}
            title="Add Photos"
          >
            🖼️
          </button>
        </div>

        {/* Hidden file input */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          onChange={(e) => addImages(e.target.files)}
          style={{ display: "none" }}
        />

        {/* Image Previews (Only shows if photos are selected) */}
        {images.length > 0 && (
          <div className="multi-image-grid" style={{ marginBottom: "15px" }}>
            {images.map((img) => (
              <div key={img.id} className="image-card">
                <div className="image-preview-wrapper">
                  <img
                    src={img.previewUrl}
                    alt="preview"
                    className="preview-image"
                  />
                  {img.hasOverlay && img.processedCanvas && (
                    <canvas
                      className="overlay-canvas"
                      width={img.processedCanvas.width}
                      height={img.processedCanvas.height}
                      ref={(node) =>
                        node &&
                        img.processedCanvas &&
                        node
                          .getContext("2d")
                          .drawImage(img.processedCanvas, 0, 0)
                      }
                    />
                  )}
                </div>

                <div
                  className="image-actions"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "5px 10px",
                    boxSizing: "border-box",
                  }}
                >
                  {/* Display the timestamp if it exists, otherwise leave blank space */}
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#555",
                      fontWeight: "bold",
                    }}
                  >
                    {img.timestamp ? img.timestamp : ""}
                  </div>

                  <button
                    className="photovault-remove-btn"
                    onClick={() => removeImage(img.id)}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "red",
                      fontSize: "18px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ×
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Action Buttons - Styled Blue with White Text */}
        <div
          className="photovault-actions"
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            marginTop: "15px",
          }}
        >
          <button
            type="button"
            className="photovault-clear-btn"
            onClick={clearAll}
            disabled={images.length === 0 || isSubmitting}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "10px 15px",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Clear All
          </button>

          <button
            className="photovault-submit-btn"
            onClick={handleSubmit}
            disabled={images.length === 0 || isSubmitting}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "10px 15px",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {isSubmitting
              ? "Posting..."
              : `Upload ${images.length} Image${
                  images.length !== 1 ? "s" : ""
                }`}
          </button>

          <button
            type="button"
            className="camera-open-btn"
            onClick={openCamera}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "10px 15px",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            📸 Open Camera
          </button>
        </div>

        {/* Absolute Bottom Right Checkmark Toggle */}
        <button
          type="button"
          onClick={() => {
            setIsOcancerzMode(!isOcancerzMode);
            clearAll(); // Clears the queue whenever you switch modes
          }}
          style={{
            position: "absolute",
            bottom: "15px",
            right: "15px",
            padding: "5px 10px",
            borderRadius: "4px", // Block edges instead of a circle
            backgroundColor: isOcancerzMode ? "#28a745" : "#ffffff", // Green when checked, white when not
            color: isOcancerzMode ? "white" : "#333",
            border: isOcancerzMode ? "1px solid #28a745" : "1px solid gray", // Gray outline
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: "14px",
            transition: "all 0.3s ease",
            zIndex: 10,
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          }}
          title="Toggle TempleGrid / Ocancerz Capture"
        >
          <span style={{ marginRight: "6px" }}>tgrid</span>
          <span>{isOcancerzMode ? "✔" : ""}</span>
        </button>

        {/* Camera Modal - Light Theme */}
        <div>
          {showCamera && (
            <div
              className="camera-modal-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                className="camera-modal"
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  width: "90%",
                  maxWidth: "600px",
                  maxHeight: "90vh", // Allows it to fit on mobile screens
                  overflowY: "auto", // Allows scrolling inside the modal
                  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                }}
              >
                <div
                  className="camera-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <h3 style={{ color: "#333", margin: 0 }}>Camera</h3>
                  {hasMultipleCameras && (
                    <button
                      onClick={switchCamera}
                      className="switch-camera-btn"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid gray",
                        color: "blue",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      🔄 Switch Camera
                    </button>
                  )}
                </div>

                {cameraError && <p style={{ color: "red" }}>{cameraError}</p>}

                {/* We render the video ALWAYS, but hide it if a photo is captured. This stops the black screen bug. */}
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  muted
                  style={{
                    width: "100%",
                    maxHeight: "60vh",
                    background: "#f0f0f0",
                    borderRadius: "8px",
                    objectFit: "cover",
                    transform:
                      currentFacingMode === "user" ? "scaleX(-1)" : "none",
                    display: !capturedPhoto ? "block" : "none", // Toggles visibility without deleting element
                  }}
                />

                {capturedPhoto && (
                  <img
                    src={capturedPhoto}
                    alt="captured"
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      display: "block",
                    }}
                  />
                )}

                {/* DEBUG INFO BOX - Light Theme */}
                <pre
                  style={{
                    background: "#f8f9fa",
                    color: "#333",
                    padding: "10px",
                    fontSize: "12px",
                    maxHeight: "100px",
                    overflow: "auto",
                    whiteSpace: "pre-wrap",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    marginTop: "15px",
                  }}
                >
                  {debugInfo || "Waiting for debug info..."}
                </pre>

                {/* Camera Controls - White BG, Gray Border, Blue Text */}
                <div
                  className="camera-controls"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    marginTop: "15px",
                    flexWrap: "wrap", // Helps buttons fit on small mobile screens
                  }}
                >
                  {!capturedPhoto ? (
                    <button
                      onClick={handleCaptureClick}
                      className="capture-btn"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid gray",
                        color: "blue",
                        padding: "10px 20px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      📸 TAKE PHOTO
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={handleRetake} // Uses our new function to delete from queue!
                        style={{
                          backgroundColor: "white",
                          border: "1px solid gray",
                          color: "blue",
                          padding: "10px 20px",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        Retake
                      </button>
                      <button
                        onClick={closeCamera}
                        style={{
                          backgroundColor: "white",
                          border: "1px solid gray",
                          color: "blue",
                          padding: "10px 20px",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        ✅ Use Photo
                      </button>
                    </>
                  )}
                  <button
                    onClick={closeCamera}
                    style={{
                      backgroundColor: "white",
                      border: "1px solid gray",
                      color: "blue",
                      padding: "10px 20px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <p
          className="photovault-info"
          style={{ marginTop: "15px", color: "#666" }}
        >
          {images.length} / {MAX_IMAGES} images selected
        </p>
      </div>
    </div>
  );
};
export default TgUserInputtgridfungo;
